import React from 'react';
import './plugins/plugins'
import './styles/App.scss';


/** REDUX **/
import {Provider} from 'react-redux'
import store from './config/store'

import BoardComponent from './game/board/components/BoardComponent'
import HeaderComponent from './layout/components/HeaderComponent'
import ConnectedComponent from './shared/connecter/ConnectedComponent'
import StatsComponent from './game/stats/components/StatsComponent'
import {green900, green700} from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import OrientationComponent from './shared/orientation/components/OrientationComponent'
import {connect} from 'react-redux'

import ResetComponent from './layout/dialogs/ResetComponent'
import DrawerComponent, {RightDrawerComponent} from './layout/components/DrawerComponent'

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: green700,
    },
    appBar: {
        color: green900
    }
});
const crimsonTheme = getMuiTheme({
    palette: {
        primary1Color: '#5b1614',
    },
    appBar: {
        color: 'rgba(0,0,0,.3)'
    }
});

function DummyFrame(props) {
    return (<div className="card" style={{padding: '20px 60px', backgroundColor: '#FFF'}}>
        {props.children}
    </div>)
}

const MainComponent = connect((store) => ({settings: store.settings}))(class extends React.Component {
    render() {
        const {settings} = this.props
        const component = settings.route === 'board' ? <BoardComponent/> : <DummyFrame><StatsComponent/></DummyFrame>
        return (<OrientationComponent>{component}</OrientationComponent>)
    }
})

class AppWrapper extends ConnectedComponent {
    constructor() {
        super()
        this.subscribe('settings')
    }

    render() {
        const props = this.props
        const crimson = this.store.settings.get('theme')
        return (<MuiThemeProvider muiTheme={crimson === 'crimson' ? crimsonTheme : muiTheme}>
            <div className={'App ' + crimson}>
                <HeaderComponent openSecondary={props.toggleSecondaryMenu} toggleMenu={props.toggleMenu}/>
                <MainComponent/>
                <DrawerComponent newGameMenu={() => props.toggleNewGame(true)} open={props.primaryMenu}
                                 toggleMenu={props.toggleMenu}/>
                <RightDrawerComponent open={props.secondaryMenu} toggleMenu={props.toggleSecondaryMenu}/>
                <ResetComponent open={props.newGameMenu} handleOpen={() => props.toggleNewGame(true)}
                                handleClose={() => props.toggleNewGame(false)}/>
            </div>
        </MuiThemeProvider>)
    }
}

//
// const AppWrapper = connect((store) => ({theme: store.settings.theme}))(class extends React.Component {
//
//     render() {
//         const props = this.props
//         return (<div className={'App ' + props.theme}>
//             <HeaderComponent openSecondary={props.toggleSecondaryMenu} toggleMenu={props.toggleMenu}/>
//             <MainComponent/>
//             <DrawerComponent newGameMenu={() => props.toggleNewGame(true)} open={props.primaryMenu}
//                              toggleMenu={props.toggleMenu}/>
//             <RightDrawerComponent open={props.secondaryMenu} toggleMenu={props.toggleSecondaryMenu}/>
//             <ResetComponent open={props.newGameMenu} handleOpen={() => props.toggleNewGame(true)}
//                             handleClose={() => props.toggleNewGame(false)}/>
//         </div>)
//     }
// })


class App extends React.Component {
    constructor() {
        super()
        this.state = {
            primaryMenu: false,
            secondaryMenu: false,
            newGameMenu: false
        }
    }

    toggleMenu = () => this.setState({
        primaryMenu: !this.state.primaryMenu
    })

    toggleSecondaryMenu = () => this.setState({
        secondaryMenu: !this.state.secondaryMenu
    })

    toggleNewGame = (status) => this.setState({newGameMenu: typeof status === 'boolean' ? status : !this.state.newGameMenu})

    // handleOpen = () => {
    //     this.setState({newGameMenu: true});
    // };
    //
    // handleClose = () => {
    //     this.setState({newGameMenu: false});
    // };


    render() {
        return (
            <Provider store={store}>

                <AppWrapper
                    primaryMenu={this.state.primaryMenu}
                    secondaryMenu={this.state.secondaryMenu}
                    newGameMenu={this.state.newGameMenu}
                    toggleNewGame={this.toggleNewGame}
                    toggleMenu={this.toggleMenu}
                    toggleSecondaryMenu={this.toggleSecondaryMenu}/>

            </Provider>
        );
    }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js